import { type FormHTMLAttributes, type ReactNode, type SubmitEvent } from "react";
import { Stack } from "@mui/material";

export type FormProps = Omit<FormHTMLAttributes<HTMLFormElement>, "onSubmit" | "children"> & {
  onSubmit?: (e: SubmitEvent<HTMLFormElement>) => void;
  width?: string | number;
  spacing?: number;
  marginBottom?: string | number;
  isCentered?: boolean;
  children?: ReactNode;
  "data-testid"?: string;
};

export const Form = ({
  onSubmit,
  width = "36rem",
  spacing = 4,
  marginBottom = 0,
  isCentered = false,
  children,
  ...rest
}: FormProps) => {
  return (
    <form onSubmit={onSubmit} {...rest}>
      <Stack
        spacing={spacing}
        sx={{ maxWidth: width, mb: marginBottom, mx: isCentered ? "auto" : undefined }}>
        {children}
      </Stack>
    </form>
  );
};
